import type { Company } from '~~/entities/company'

export enum Role {
  // Developer / Management Employees
  SuperAdmin = 'super_admin',

  // Client Facing Employees
  AccountLead = 'account_lead',

  // Clients who can use Editor
  CompanyAdmin = 'company_admin',

  // This is a convenience role to combine super admin and account lead
  // to make the code simpler to follow.
  InternalAdmin = 'internal_admin',
}

export interface User {
  id: number
  name: string
  initials: string | null
  email_address: string | null
  profile_image_path?: string // Sent by socket, should ideally consolidate this with profile_image later
  profile_image?: string
  linkedin_id?: string
  is_super_admin: boolean
  roles: { id: number; key: Role; description: Role }[]
  companies: Company[]
  status: 'A' | 'B' | 'P' /* A: Active, B: Blocked, P: Pending */
  permissions?: UserPermission[]
}

export interface UserPermission {
  id: number
  user_id: number
  company_id: number
  permission_flag: UserPermissionFlag
}

export enum UserPermissionFlag {
  Presentations = 'presentations',
  DORA = 'DORA',
  Data = 'data',
  CompanyAdmin = 'admin',
}

export interface UserWithUIState extends User {
  access_type: string
}

export interface GuestUser {
  name?: string
  shareCode?: string
  email?: string
}

export interface ClientDevice {
  browser: string | null
  browserVersion: string | null
  device: string | null
  fingerprint: string | number
  isMobile: boolean | null
  isMobileIOS: boolean | null
  os: string
  osVersion: string | null
}
